
$(document).ready(function () {
    if (typeof window.thumbnailObserver === 'undefined') {
        window.thumbnailObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'aria-current' &&
                    mutation.target.getAttribute('aria-current') === 'true'
                ) {
                    var selected_thumb_img = mutation.target.querySelector('img').getAttribute('alt');

                    $('.product-form__input .variant-grp input').each(function () {
                        if ($(this).val() === selected_thumb_img) {
                            $(this).prop('checked', true).trigger('change');
                            var variant_id = $(this).attr('data-variant-id');
                            console.log(variant_id, 'variant_idvariant_idvariant_idvariant_idvariant_id');
                            $('form[action="/cart/add"] [name="id"]').val("");
                            $('form[action="/cart/add"] [name="id"]').val(variant_id);
                        }
                    });
                }
            });
        });

        document.querySelectorAll('.thumbnail').forEach(function (thumbnail) {
            window.thumbnailObserver.observe(thumbnail, {
                attributes: true,
                attributeFilter: ['aria-current']
            });
        });
    }
})